export const authRoles = [
  {
    id: "admin",
    name: "Admin",
    prop: "isAdmin",
  },
  {
    id: "supervisor",
    name: "Supervisor",
    prop: "isSupervisor",
  },
  {
    id: "case_manager",
    name: "Case Manager",
    prop: "isCase_manager",
  },
];
